import { useContext } from "react";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../store/ui-context";

export const useAPISaveAttendance = () => {
    const uiContext = useContext(UiContext);
    const { requestPost, loading } = useAPIRequest();

    const save = async (data, onSuccess) => {
        return requestPost({
            fullUrl: `/api/masterdata/attendance/save`,
            body: data,
            onSuccess: ({ message, data }) => {
                uiContext.showSuccessMsg("Success", message || "Attendance saved successfully");

                if (onSuccess) {
                    onSuccess(data);
                }
            },
            onError: ({ message }) => {
                uiContext.showErrorMsg("Error", message || "Failed to save attendance");
            },
        });
    };

    const saveMany = async (dataArray, onSuccess) => {
        return requestPost({
            fullUrl: `/api/masterdata/attendance/savemany`,
            body: dataArray,
            onSuccess: ({ message, data }) => {
                uiContext.showSuccessMsg("Success", message || "Attendance saved successfully");

                if (onSuccess) {
                    onSuccess(data);
                }
            },
            onError: ({ message }) => {
                uiContext.showErrorMsg("Error", message || "Failed to save attendance");
            },
        });
    };

    const handleSaveAttendance = async (attendanceData, onSuccess) => {
        return save(attendanceData, onSuccess);
    };

    const handleSaveManyAttendance = async (attendanceDataArray, onSuccess) => {
        return saveMany(attendanceDataArray, onSuccess);
    };

    return {
        loading,
        save,
        saveMany,
        handleSaveAttendance,
        handleSaveManyAttendance,
    };
};
